'use strict';

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DigestSpeedMonitorDirective=class DigestSpeedMonitorDirective extends BaseControllerBackedDirective{
get template(){return`
        <div id="digest-speed-monitor" ng-show='controller.enabled' title="Current Digest Speed, FPS, and Watcher Count"></div>`}

get optionalObjectBindings(){
return['enabled'];
}

get controller(){return DigestSpeedMonitorDirectiveController}

get $inject(){return['$scope','$interval']}};


let stopMonitoring;let
DigestSpeedMonitorDirectiveController=class DigestSpeedMonitorDirectiveController{
constructor($scope,$element,$interval){
this._$scope=$scope;
this._$element=$element;
this._$interval=$interval;

$scope.$evalAsync(()=>{
this.enabled=_.exists(this.enabled)?this.enabled:!0;
});

this._currentSpeedClass='';

if(_.exists(stopMonitoring)){
clearInterval(stopMonitoring);
}

stopMonitoring=setInterval(()=>{
if(!this.enabled){
return;
}

const digestSpeed=AngularHelpers.getDigestSpeed({logResult:!1});
const numWatchers=AngularHelpers.getWatchers()._total;
const watcherDiff=this._numWatchers?numWatchers-this._numWatchers:0;

this._watcherDiff=watcherDiff;
this._numWatchers=numWatchers;

let speedClass;
if(digestSpeed+watcherDiff<1){
speedClass='great';
}else if(digestSpeed+watcherDiff<10){
speedClass='good';
}else if(digestSpeed+watcherDiff<20){
speedClass='okay';
}else if(digestSpeed+watcherDiff<50){
speedClass='warn';
}else if(digestSpeed+watcherDiff<150){
speedClass='bad';
}else{
speedClass='terrible';
}

this._update(digestSpeed,speedClass,numWatchers,watcherDiff);
},5000);

$scope.$on('$destroy',()=>{
clearInterval(stopMonitoring);
});
}

_update(digestSpeed,speedClass,numWatchers,watcherDiff){
this._monitorElement.className=speedClass;
this._monitorElement.innerText=`${digestSpeed.toFixed(3)} ms ${(1000/digestSpeed).toFixed(0)} fps ${numWatchers}${watcherDiff!==0?'('+(watcherDiff>0?'+':'')+watcherDiff+')':''}w`;
}

get _monitorElement(){
return this.__monitorElement||(this.__monitorElement=this._$element.find('#digest-speed-monitor')[0]);
}};



module.exports=DigestSpeedMonitorDirective;
//# sourceMappingURL=digestSpeedMonitorDirective.js.map
